export const textareaTheme = {
  baseStyle: {
    _readOnly: {
      cursor: 'not-allowed',
      background: 'gray.100 !important'
    }
  },
  defaultProps: {
    size: 'sm'
  }
}
